var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import renderJsonPathCss from "./render-json-path.css.js";
const bracketRegex = /(\{)([\w.\-_$:]+)(})|(:)([\w.\-_$:]+)/g;
const pathRegex = /(\[)(["']?)([\w${}:.\-_/\\]+)(['"]?)(])/g;
let RenderJSONPathComponent = class RenderJSONPathComponent extends LitElement {
    constructor() {
        super();
        this.path = "/";
        this.selected = false;
        this.chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    }
    replaceBrackets(value) {
        let m;
        let returnString = value;
        while ((m = bracketRegex.exec(value)) !== null) {
            m.forEach((match, groupIndex) => {
                if (match !== undefined && (groupIndex === 1 || groupIndex === 4)) {
                    returnString = returnString.replaceAll(match, '<span class="bracket">' + match + '</span>');
                }
                if (match !== undefined && (groupIndex === 2 || groupIndex === 5)) {
                    returnString = returnString.replaceAll(match, '<span class="param-nested">' + match + '</span>');
                }
                if (match !== undefined && groupIndex === 3) {
                    returnString = returnString.replaceAll(match, '<span class="bracket">' + match + '</span>');
                }
            });
        }
        return returnString;
    }
    breakPath() {
        let segments = this.path.split(".");
        if (segments.length > 0) {
            if (segments[0] == '$')
                segments = segments.slice(1, segments.length);
        }
        let cleaned = segments.join(".");
        const path = cleaned;
        let matchMap = new Map();
        let match;
        // build a match map and replace the matches with a random string that matches the length of the match
        while ((match = pathRegex.exec(path)) !== null) {
            const size = pathRegex.lastIndex - match.index;
            const key = randomString(size, this.chars);
            matchMap.set(key, match);
            cleaned = cleaned.substring(0, match.index) + key + cleaned.substring(pathRegex.lastIndex);
        }
        // replace dots with rendered dots
        cleaned = cleaned.replaceAll(".", '<span class="dot">.</span>');
        // iterate through match map, build the segments and replace the random strings with the segments
        matchMap.forEach((value, key) => {
            let rendered = [];
            if (value[1] !== undefined) {
                rendered.push('<span part="path" class="bracket">' + value[1] + '</span>');
            }
            if (value[2] !== undefined) {
                rendered.push(value[2]);
            }
            if (value[3] !== undefined) {
                rendered.push('<span part="path" class="param">' + this.replaceBrackets(value[3]) + '</span>');
            }
            if (value[4] !== undefined) {
                rendered.push(value[4]);
            }
            if (value[5] !== undefined) {
                rendered.push('<span part="path" class="bracket">' + value[5] + '</span>');
            }
            const renderedString = rendered.join("");
            cleaned = cleaned.replaceAll(key, renderedString);
        });
        let returnString = cleaned;
        returnString = returnString.replaceAll("$", "<span class='dollar'>$</span>");
        if (returnString === '') {
            returnString = "<span part='path' class='dot'>{no path available}</span>";
        }
        return html `${unsafeHTML(returnString.toString())}`;
    }
    render() {
        return html `<span part="path" class="jsonpath ${this.selected ? 'selected' : ''}">${this.breakPath()}</span>`;
    }
};
RenderJSONPathComponent.styles = renderJsonPathCss;
__decorate([
    property()
], RenderJSONPathComponent.prototype, "path", void 0);
__decorate([
    property({ type: Boolean })
], RenderJSONPathComponent.prototype, "selected", void 0);
RenderJSONPathComponent = __decorate([
    customElement('pb33f-render-json-path')
], RenderJSONPathComponent);
export { RenderJSONPathComponent };
function randomString(length, chars) {
    let result = '';
    for (let i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}
